import * as Popover from '@givebutter/primitives/popover';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CmdSymbol } from 'components/search/CmdSymbol';
import { OsCmdSymbol } from 'components/search/OsCmdSymbol';
import { SearchBar } from 'components/search/SearchBar';
import { SearchFilterBadges } from 'components/search/SearchFilterBadges';
import { SearchResultsList } from 'components/search/SearchResultsList';
import { useCmdK } from 'components/search/useCmdK';
import { useSearchStore } from 'components/search/useSearchStore';
import { IntercomProductTourTargets } from 'constants/intercom';
import { twJoin } from 'tailwind-merge';

const SEARCH_WIDTH_MD = 'md:w-80 xl:w-[456px]';

const Search = () => {
    useCmdK();
    const { isOpen, setIsOpen, query, searchRef } = useSearchStore();

    return (
        <Popover.Root
            open={isOpen}
            onOpenChange={open => {
                if (getGivebutterOverlay()) {
                    return;
                }
                setIsOpen(open);
            }}
        >
            <Popover.Trigger
                data-intercom-target={IntercomProductTourTargets.HeaderSearch}
                className={twJoin(
                    `group ml-auto flex h-10 items-center gap-1.5 rounded-md p-2 leading-none`,
                    `sm:ml-0 sm:w-56 sm:bg-gray-700 sm:px-4 sm:py-2 sm:hover:bg-gray-500`,
                    SEARCH_WIDTH_MD,
                )}
            >
                <FontAwesomeIcon className={'text-gray-300'} icon={faSearch} />
                <div className="hidden sm:flex sm:flex-grow sm:items-center">
                    <p className={'flex-grow truncate text-start text-gray-300'}>
                        {query.length > 0 ? query : 'Search'}
                    </p>
                    <div
                        className={
                            'flex items-center gap-1 [&>*]:border-gray-500 [&>*]:text-white [&>*]:group-hover:border-gray-600'
                        }
                    >
                        <OsCmdSymbol />
                        <CmdSymbol>K</CmdSymbol>
                    </div>
                </div>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content
                    aria-label={'Search results dialog'}
                    sideOffset={-40}
                    className={twJoin(
                        `mx-[5vw] flex w-[90vw] flex-col gap-2 rounded-md bg-white drop-shadow md:mx-0`,
                        SEARCH_WIDTH_MD,
                    )}
                    onFocusOutside={e => {
                        // The bottom link in the popover causes outside focus for unknown reason
                        // We interject and focus the search again if tabfocus tries to escape
                        e.preventDefault();
                        if (!getGivebutterOverlay()) {
                            searchRef.current?.focus();
                        }
                    }}
                >
                    <SearchBar />
                    <SearchFilterBadges />
                    <SearchResultsList />
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
};

const getGivebutterOverlay = () => document.querySelector('[data-overlay-givebutter]');

export { Search };
